import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "iconShow", "iconHide", "button"]
  static values = { showLabel: String, hideLabel: String }

  toggle(event) {
    event.preventDefault()

    const hidden = this.inputTarget.type === "password"
    this.inputTarget.type = hidden ? "text" : "password"
    this.iconShowTarget.classList.toggle("hidden", !hidden)
    this.iconHideTarget.classList.toggle("hidden", hidden)
    if (this.hasButtonTarget && this.hasShowLabelValue && this.hasHideLabelValue) {
      this.buttonTarget.setAttribute("aria-label", hidden ? this.hideLabelValue : this.showLabelValue)
    }
  }
}
